import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_kodtrading.png",
      alt: "Estratégias KoD",
    },
    title: "Diversifique seus investimentos",

    // String ou array de strings
    text: "Invista com confiança com as estratégias automatizadas KoD. Nossos algoritmos avançados utilizam tecnologia de ponta para otimizar resultados e reduzir riscos, oferecendo soluções inteligentes para seus objetivos financeiros. ",
    testimonial: {
      text: "Investir é coisa séria, porque dinheiro não aguenta desaforo.",
      author: {
        name: "André Felipe, Fundador da KoD",
        // picture:
        //   "https://ontick-img.s3.sa-east-1.amazonaws.com/mauro_quantic_profile.png",
        // },
      },
    },
  },

  strategies: {
    title: "Estratégias KoD",
    heading: "Sua melhor alternativa para investir com segurança.",
    subtitle:
      "Algoritmos testados e aprovados seguindo os melhores requisitos de eficiência e rentabilidade. Investir em renda variável nunca foi tão fácil.",
  },

  cta: {
    title: "Vamos começar? ",
    subtitle: "Escolha seu plano e ative já!",
    // buttonText: "Ativar extensão",
  },

  about: {
    title: "Sobre a empresa",
    subtitle: "A KoD",
    col1: [
      "KoD é uma empresa especializada no desenvolvimento de estratégias automatizadas de investimento, criada por um trader de alta performance com mais de 10 anos de experiência no mercado financeiro. Isso faz total diferença quando o assunto é resultado.",
      "Com foco em inovação e segurança, utilizamos algoritmos avançados, inteligência artificial e análise quantitativa para otimizar decisões financeiras e operar com eficiência nos mercados.",
    ],
    col2: [
      "Nossas soluções são testadas, transparentes e personalizadas para atender às necessidades específicas de cada cliente, garantindo resultados consistentes e confiáveis em um ambiente de alta performance. ",
    ],
  },

  stats: {
    title: "Alguns indicadores KoD",
    subtitle: "Experiência e tecnologia andando juntas. ",
    data: [
      {
        value: "+10",
        description: "Anos de experiência",
      },
      {
        value: "+10k",
        description: "Cenários de mercado testados",
      },
      {
        value: "+30%",
        description: "de ganho em mitigação de riscos financeiros",
      },
    ],
  },

  features: {
    // type: 2,
    title: "Por que utilizar os robôs da KoD?",
    subtitle: "Veja quais as principais vantagens dos nossos robôs.",
    data: [
      {
        icon: iconsSet.calendar,
        title: "Decisões Precisas",
        description:
          "Algoritmos avançados analisam grandes volumes de dados em tempo real para identificar as melhores oportunidades de investimento.",
      },
      {
        icon: iconsSet.clock,
        title: "Redução de Riscos",
        description:
          "Estratégias baseadas em inteligência artificial minimizam a exposição a erros humanos e ajustam-se rapidamente às mudanças do mercado. ",
      },
      {
        icon: iconsSet.code,
        title: "Resultados Consistentes",
        description:
          "Nossas soluções são testadas e otimizadas para entregar desempenho confiável em diferentes condições de mercado.",
      },
      {
        icon: iconsSet.hourglass,
        title: "Personalização",
        description:
          "Adaptamos as estratégias às necessidades e aos objetivos específicos de cada perfil de cliente, garantindo alinhamento com o seu perfil de investidor.",
      },
      {
        icon: iconsSet.cloud,
        title: "Eficiência Operacional",
        description:
          "Operações automatizadas garantem agilidade e eliminam atrasos, maximizando os lucros em tempo real.",
      },
      {
        icon: iconsSet.chat_round,
        title: "Transparência e Segurança",
        description:
          "Soluções tecnológicas robustas e processos auditáveis oferecem total clareza e confiança para o cliente. ",
      },
      // ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "As estratégias da KoD transformaram minha forma de investir. A automação e os algoritmos avançados não só melhoraram meus resultados, mas também me deram mais tempo para focar em outras prioridades. Recomendo sem dúvidas!",
      author: "André Silva",
      job: "Analista Financeiro",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
    },
    {
      text: "Com a KoD, encontrei a segurança e a eficiência que sempre busquei nos investimentos. As soluções personalizadas e o suporte transparente me deixaram confiante em cada decisão. Uma parceria que fez toda a diferença!",
      author: "Mariana Lopes",
      job: "Empresária",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça nossos planos e vantagens!",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
